module.exports = __webpack_public_path__ + "img/solutions1.71c769b.png";